import React from 'react';
import { LogoWordmarkBrand } from '@eventbrite/legacy-eds.iconography';

export const DEFAULT_LOGO_TYPE = <LogoWordmarkBrand />;
export const DEFAULT_LOGO_COLOR = 'ui-orange';
export const DEFAULT_LOGO_SIZE = {
    width: '99px',
    height: '20px',
};

export const DEFAULT_LOGO_TITLE = 'Eventbrite';
